<template>
    <div class="index">
      <div class="header header1 ">
        <div class="left">
          <img src="@/assets/img/logo2.png" alt="">
        </div>
        <div class="right">
          <ul>
            <li v-for="(item,index) in menuList" :key="index" @click="selectMenu(index)">
              <div :class="selectIndex == index?'active':''" >{{item.name}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div style="height: 80px"></div>
      <div class="main">
        <div class="title">商业模式第一篇：十种商业模式解析</div>
        <div class="time">发布时间：2020-11-01</div>
        <div class="con">
          <div class="left">
            <img src="@/assets/img/new1.png" alt="" >
            向前看20年，当时有多少实力雄厚的公司霸占着行业的主导地位，例如：摩托罗拉、诺基亚、武富士、柯达、雷曼兄弟、日本中道等等，在经历了数十年的成功经营后如今却已经销声匿迹。

            特别印象深刻的是诺基亚，几乎在任何场所都能听到诺基亚特定的铃声。小编当时比较年轻，一度认为诺基亚是身份的象征，如今却沦落到了“老年机”的行列，字体大，按键方便。

            如果以上站在商业模式角度分析，这些公司都没能及时的调整他们的商业模式来适应新的环境变化，而是满足于昔日的辉煌。

            商业模式是不断创新的，它没有固定的模式恒久不变，要不断尝试把商业模式套用在所没涉及过的行业中或者从没实用过的环境中，但是不管怎么创新，怎么变化，都围绕这小编解析的这些商业模式。当核心产品价格低下时，会通过附加产品使总体价格上升的商业模式。客户极低的价格购买核心产品，但是为了满足具体需求还需要另外购买其他产品，最终花费的价钱要比预期的多，而商户也从中收取更大的利益。

            例如：装修行业就是一个附加商业模式，前期的报价定方案，后期的增加项目及改动项目来使整体价格上涨。

            附加商业模式已经存在很多年了，特别是服务行业，通过提供特殊服务和附加产品，充分利用客户花更多钱的意愿是符合逻辑的。

            旅游业也广泛使用附加商业模式，因为竞争激烈所以通过极低的价格吸引顾客，然后在旅游过程中销售贵宾客房、饮料、特殊活动、景点购物来提升整体利润。

            确保这个模式的良好运行的前提是，客户能够先选择一个基础产品，然后增加一些客户对其价格敏感度较低的可选产品。最初，客户会在包括价格的理性标准基础上做决定，后来就会变成了以情感为动机的购买模式了。一旦你在高铁列车上饿了，就不在乎列车上的快餐比饭店贵多少钱。

          </div>
          <div class="right">
            <div class="con" v-for="i in 4" :key="i" >
              <img src="@/assets/img/new1.png" alt="" >
              <div class="span">
                一个好的内容策略可以帮助用户参与你
              </div>
              <div class="time">发布时间:2020-08-25</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/25 16:56.
     */
    import homeBg1 from '@/assets/img/homeBg.png'
    import homeBg2 from '@/assets/img/homeBg2.png'
    export default {
        mounted() {
          window.scrollTo(0,0);
        },
        components: {},
        props: {},
        data() {
            return {
              selectIndex:3,
              menuList:[
                {name:'首 页',title:'面向电商互联网服务提供商',des:'业务多元化 | 服务定制化 | 市场全球化',img:homeBg1},
                {name:'关于我们',title:'关于我们',des:'态度正确、能力非凡、品质高尚、追求极致',img:homeBg2},
                {name:'解决方案',title:'金融支付',des:'便携高效 安全支付 全方位个性服务',img:homeBg2},
                {name:'新闻资讯',title:'新闻资讯',des:'我们一起去创造、发现更对',img:homeBg2},
                {name:'加入我们',title:'加入我们',des:'我们在一起，就会了不起',img:homeBg2},
                {name:'联系我们',title:'联系我们',des:'一起去发现更多',img:homeBg2},
              ],
            }
        },
        computed: {},
        methods: {
          selectMenu(index){
            window.scrollTo(0,0);
            this.selectIndex = index
            switch (index) {
              case 0:this.$router.push({path:'/home'});break;
              case 1:this.$router.push({path:'/aboutUs'});break;
              case 2:
                this.$router.push({path:'/solutionPay'});
                this.paySelectIndex = 0
                break;
              case 3:this.$router.push({path:'/new'});break;
              case 4:this.$router.push({path:'/joinUs'});break;
              case 5:this.$router.push({path:'/contactUs'});break;
            }

          }
        },
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>


<style lang="less" scoped>
  .slideUp{
    animation-name:slideUp;
    -webkit-animation-name:slideUp;
  }
  @keyframes slideUp{
    0%{
      transform: translateY(-100%);
    }
    100%{
      transform: translateY(0);
    }
  }
  .slideDown{
    animation-name:slideDown;
    -webkit-animation-name:slideDown;
  }
  @keyframes slideDown{
    0%{
      transform: translateY(0);
    }
    100%{
      transform: translateY(-100%);
    }
  }
  .index{
    width: 100%;
    min-width: 1920px;
    background: #F8F8F8;
    overflow: auto;

    .header{
      width: 100%;
      min-width: 1920px;
      height: 50px;
      line-height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: white;
      padding: 0 6%;
      box-sizing: border-box;
      .left{
        font-size: 30px;
        font-family: HuXiaoBo-NanShen;
        font-weight: 400;
        img{
          display: block;
        }
      }
      .right{
        position: relative;
        .kailong {
          width: 0;
          height: 0;
          border-right: 20px solid transparent;
          border-left: 20px solid transparent;
          border-bottom: 20px solid white;
          position: absolute;
          top: 85px;
          left: 246px;
        }
        .programActive{
          color: #FE3B35;
        }
        .program{
          position: absolute;
          top: 100px;
          left: 56px;
          width: 420px;
          height: 45px;
          line-height: 45px;
          background: #FFFFFF;
          border-radius: 5px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #232330;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          cursor: pointer;
        }
      }
      .right ul{
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        display: inline-flex;
        li{
          list-style: none;
          padding-left: 20px;
          padding-right: 20px;
          cursor: pointer;
          box-sizing: content-box;
          /*font-weight: bold;*/
        }
        li .active:after{
          content: '';
          display: block;
          bottom: 0;
          width: 100%;
          height: 5px;
          background: #FE3B35;
          transition: all .2s linear;
          -webkit-transition: all .2s linear;
          left: 0;
          right: 0;
          margin: auto;
        }
        li div:after{
          content: '';
          display: block;
          bottom: 0;
          width: 0%;
          height: 5px;
          background: #FE3B35;
          transition: all .2s linear;
          -webkit-transition: all .2s linear;
          left: 0;
          right: 0;
          margin: auto;
          color: #FE3B35;
        }
        li div:hover:after{
          width: 100%;
        }
        li div:hover{
          color: #FE3B35;
        }
        .active{
          color: #FE3B35;
          /*font-weight: bold;*/
          /*border-bottom: 5px solid #FE3B35;*/
        }
      }
    }
    .header1{
      width: 100%;
      min-width: 1920px;
      color: #333333;
      height: 80px;
      z-index: 999;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      padding: 25px 6%;
      background: #fff;
      animation-duration:.5s;
      /* Safari and Chrome */
      -webkit-animation-duration:.5s;
      box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
    }
    .main{
      width: 1495px;
      height: 100%;
      margin: 0 auto;
      background: #FFFFFF;
      padding: 60px 98px;
      .title{
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        margin-bottom: 10px;
      }
      .time{
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .con{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .left{
          text-align: justify;
          margin-top: 30px;
          width: 741px;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #040000;
          line-height: 28px;
          img{
            width: 741px;
            margin-bottom: 30px;
          }
        }
        .right{
          width: 402px;
          padding-left: 39px;
          border-left: 1px solid rgba(0,0,0,0.2);
          margin-top: 30px;
          .con{
            width: 402px;
            display: flex;
            flex-direction: column;
          }
          img{
            width: 402px;
          }
          .span{
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            line-height: 19px;
            opacity: 0.7;
            margin-top: 16px;
          }
          .time{
            margin-bottom: 16px;

            opacity: 0.7;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            line-height: 29px;
          }
        }
      }
    }
  }
</style>

